import { prefixerM } from '.'

export const ROUTE_GESTION_IMPUESTOS = prefixerM('gestion-impuestos')
export const ROUTE_GESTION_REGIMENES_ADUANEROS = prefixerM('gestion-regimenes-aduaneros')
export const ROUTE_GESTION_DIVISAS = prefixerM('gestion-divisas')
